import Model from './Model'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default class Campaign extends Model {
  resource() {
    return 'admin/campaigns'
  }

  get addedDate() {
    return dayjs.utc(this.created_at).local().format('MMM DD, YYYY hh:mm A')
  }

  get sentDate() {
    return dayjs.utc(this.date_sent).local().format('MMM DD, YYYY hh:mm A')
  }
}
